import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';

const defaultValues = {
  id: undefined as number | undefined,
  name: "",
  image: "",
  uid: "",
  adminScope: null as "system" | "company" | null,
  adminCompanyId: null as number | null,
  permissions: {
    views: [] as string[],
    actions: [] as string[]
  }
}

const updateUser = (newConf: any) => {}
const UserContext = createContext({ user: defaultValues, updateUser });

export const UserProvider = ({ children }: any) => {
  const [user, setUser] = useState(defaultValues);
  const updateUser = useCallback((newConfig: any) => {
    setUser((prevConfig) => ({ ...prevConfig, ...newConfig }));
  }, []);

  const contextValue = useMemo(() => ({
    user,
    updateUser,
  }), [user, updateUser]);

  return (
    <UserContext.Provider value={contextValue}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  return useContext(UserContext);
};
